import React, { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { toast } from 'react-toastify';
import LoadingSpinner from '../components/LoadingSpinner';
import './Services.css';
import jsPDF from 'jspdf';

const API_BASE = process.env.REACT_APP_FILE_API_URL;

const FileStats = () => {
  const { user } = useAuth0();
  const username = user?.nickname || user?.name || user?.email;
  const [stats, setStats] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [view, setView] = useState('chat'); // chat, table, bar

  useEffect(() => {
    const fetchStats = async () => {
      setLoading(true);
      try {
        const res = await fetch(`${API_BASE}/files/user-stats/${username}`, {
          headers: {
            'Authorization': 'Basic YWRtaW46YWRtaW4='
          }
        });
        if (!res.ok) throw new Error('Failed to fetch stats');
        setStats(await res.json());
        setError('');
      } catch (err) {
        setError(`Could not load stats: ${err.message}`);
        toast.error('Failed to load file statistics');
      } finally {
        setLoading(false);
      }
    };
    if (username) fetchStats();
  }, [username]);

  const handleDownloadPDF = () => {
    if (!stats) return;
    const doc = new jsPDF();
    doc.setFontSize(18);
    doc.text('File Statistics', 14, 18);
    doc.setFontSize(12);
    doc.text(`Files: ${stats.fileCount}`, 14, 32);
    doc.text(`Storage Used: ${stats.readableSize}`, 14, 40);
    doc.save('file-stats.pdf');
  };

  if (loading) {
    return (
      <div className="service-page">
        <h1>File Stats</h1>
        <div className="loading-overlay">
          <LoadingSpinner />
        </div>
      </div>
    );
  }

  return (
    <div className="service-page">
      <h1>File Stats</h1>
      <div style={{ display: 'flex', gap: '1rem', marginBottom: 16 }}>
        <button onClick={() => setView('chat')} className={view === 'chat' ? 'file-preview-link' : ''}>Chat View</button>
        <button onClick={() => setView('table')} className={view === 'table' ? 'file-preview-link' : ''}>Table View</button>
        <button onClick={() => setView('bar')} className={view === 'bar' ? 'file-preview-link' : ''}>Bar View</button>
        <button onClick={handleDownloadPDF} className="file-preview-link">Download PDF</button>
      </div>
      {error && <div className="file-error">{error}</div>}
      {stats && (
        <div>
          {view === 'chat' && (
            <div className="chat-bubble" style={{ background: '#f1f5f9', padding: 16, borderRadius: 12, marginBottom: 16, maxWidth: 400 }}>
              <b>Hi {username || 'user'}!</b> <br />
              You have <b>{stats.fileCount}</b> files stored, using a total of <b>{stats.readableSize}</b> of space. Keep up the great work!
            </div>
          )}
          {view === 'table' && (
            <table className="file-stats-table" style={{ borderCollapse: 'collapse', marginBottom: 16 }}>
              <thead>
                <tr style={{ background: '#e0e7ff' }}>
                  <th style={{ padding: 8, border: '1px solid #cbd5e1' }}>Stat</th>
                  <th style={{ padding: 8, border: '1px solid #cbd5e1' }}>Value</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ padding: 8, border: '1px solid #cbd5e1' }}>Files</td>
                  <td style={{ padding: 8, border: '1px solid #cbd5e1' }}>{stats.fileCount}</td>
                </tr>
                <tr>
                  <td style={{ padding: 8, border: '1px solid #cbd5e1' }}>Storage Used</td>
                  <td style={{ padding: 8, border: '1px solid #cbd5e1' }}>{stats.readableSize}</td>
                </tr>
              </tbody>
            </table>
          )}
          {view === 'bar' && (
            <div style={{ maxWidth: 400, marginBottom: 16 }}>
              <div style={{ marginBottom: 8 }}>Files</div>
              <div style={{ background: '#e0e7ff', borderRadius: 8, height: 24, marginBottom: 16 }}>
                <div style={{ width: `${Math.min(stats.fileCount * 10, 100)}%`, background: '#2563eb', height: '100%', borderRadius: 8, color: 'white', textAlign: 'center', lineHeight: '24px' }}>
                  {stats.fileCount}
                </div>
              </div>
              <div style={{ marginBottom: 8 }}>Storage Used</div>
              <div style={{ background: '#e0e7ff', borderRadius: 8, height: 24 }}>
                <div style={{ width: '100%', background: '#10b981', height: '100%', borderRadius: 8, color: 'white', textAlign: 'center', lineHeight: '24px' }}>
                  {stats.readableSize}
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default FileStats;
